import styled from "styled-components";

interface iErrorProps {
    showError?: boolean;
  }
  
export const Container = styled.main`
    background-color: ${props => props.theme.colors.brand4.pure};
    height: 100%;
    width: 100%;
    padding: 40px 0;
    
    // .h1__createWishlist--text {
    //     margin-bottom: 42px;

    //     @media(min-width:768px) {
    //         margin-bottom: 24px;
    //     }
    // }
`

export const Form = styled.form `
    margin: 0 auto;
    width: 95%;

    @media(min-width:480px) {
        width: 80%;
    }

    @media(min-width:768px) {
        width: 396px;
    }
`

export const InputLabelContainer = styled.div<iErrorProps>`
    display: flex;
    flex-direction: column;
`

export const ErrorMessage = styled.span<iErrorProps>`
    display: ${props => props.showError ? 'inline' : 'none'};
    padding: 0 6px;
    font-size: 0.89rem;
    color: #D66157;
    margin-bottom: 18px; 
    margin-top: ${props => props.showError ? `-10px` : `none`}; 
`
